<template>
<el-carousel :interval="4000" type="card" height="200px" :autoplay="false" trigger="click">
    <el-carousel-item v-for="(item, index) in service" :key="index">
        <div class="swiper">
            <div class="swiper_container">
                <div class="image">
                    <img :src="item.image ? item.image : '../../../assets/image/资源 182.png'">
                </div>
                <div class="content">
                    <div class="content_left">
                        <p>{{ titleRow(item.title).before }}</p>
                        <p>{{ titleRow(item.title).after }}</p>
                    </div>
                    <div class="content_right">
                        <p v-for="(contents, index) in item.content" :key="index">{{ contents }}</p>
                    </div>
                </div>
            </div>
        </div>
    </el-carousel-item>
</el-carousel>
</template>

<script>
import { getBanner } from '../../../util/index'

export default {
    data(){
        return {
            service : [
                {
                    title: '展厅多媒体22',
                    content: ['CAVE沉浸视频', '3折/4折/L幕视频沉浸式裸眼3D视频', '全息影像'],
                    image: require('../../../assets/image/资源 182.png')
                },
                {
                    title: '互动展示&体验内容',
                    content: ['数字创意视觉影像', '3D可视化&数字孪生', '展厅可视化创意'],
                    image: require('../../../assets/image/30.3D可视化&数字孪生图片-已选择.png')
                },
                {
                    title: '数字创意视觉影像',
                    content: ['数字创意视觉影像', '3D可视化&数字孪生', '展厅可视化创意'],
                    image: require('../../../assets/image/资源 180.png')
                },
                {
                    title: '3D可视化&数字孪生',
                    content: ['数字创意视觉影像', '3D可视化&数字孪生', '展厅可视化创意'],
                    image: require('../../../assets/image/资源 182.png')
                },
                {
                    title: '展厅可视化创意',
                    content: ['数字创意视觉影像', '3D可视化&数字孪生', '展厅可视化创意'],
                    image: require('../../../assets/image/资源 180.png')
                }
            ]
        }
    },
    mounted() {
        let page = '首页', category = '轮播图2'
        getBanner(page, category).then(res => {
            if(res.code === 200){
                let data = res.data
                const result = [];
                // 临时存储 item-title 和 item-content 的对象
                const temp = {};

                // 遍历数据，按相同的 item 前缀进行归类
                Object.keys(data).forEach(key => {
                    const [prefix, suffix] = key.split('-');
                    
                    // 如果该前缀还没有在 temp 中，先初始化
                    if (!temp[prefix]) {
                        temp[prefix] = {};
                    }

                    // 将 title 或 content 放到 temp[prefix] 中
                    temp[prefix][suffix] = data[key];
                });

                // 将 temp 对象转换为数组格式
                Object.values(temp).forEach(item => {
                    result.push({
                        title: item.title || '', // 确保没有 title 时用空字符串代替
                        // 按逗号分割 content 成数组，并去除空白项
                        content: item.content ? item.content.split('，').map(text => text.trim()) : ['', '', '']
                    });
                });
                result.forEach((item, index) => {
                    item.image = require(`../../../assets/image/1.2-${index + 1}.png`)
                })
                this.service = result
            }
        })
    },
    methods:{
        titleRow(title){
            const parts = title.split(/-{1,4}/);
            return {
                before: parts[0] || '', // 前部分
                after: parts[1] || '',  // 后部分
            };
        },
        addInnerText(){
            let buttonText = document.getElementsByClassName("el-carousel__button")
            console.log(buttonText)
            console.log(length)
            this.$nextTick(function(){
                console.log(buttonText.length);  //输出：修改后的值\
                for(var i =5, j=0; i<buttonText.length; i++, j++) {
                    console.log(buttonText[i])
                    buttonText[i].textContent=this.service[j]
                }
            });
        }
    },
    beforeMount() {
        this.addInnerText()
    }
}
</script>

<style scoped lang="less">
.swiper{
    // padding-bottom: 8rem;
    .swiper_container{
        // height: 30rem;
        // padding-bottom: 8rem;
        // background-color: green;
        position: relative;
        .image{
            height: 100%;
            width: 100%;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .content{
            color: #fff;
            background-color: rgba(0, 0, 0, 0.6);
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 177px;
            // height: 33%;
            display: flex;
            align-items: center;
            // background-color: #fff;
            .content_left{
                width: 42%;
                height: 30%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #54ceec;
                letter-spacing: 2px;
                font-size: 1.4rem;
                font-family: AliMedium;
                border-right: 1px dashed #fff;
            }
            .content_right{
                width: 50%;
                padding-left: 5rem;
                font-family: AliRegular;
                // height: 50%;
                color: #cdcdcd;
                line-height: 1.8;
            }
        }
    }
}

::v-deep .el-carousel__container{
    height: 32rem !important;
}
::v-deep .el-carousel__button{
    height: 2.5rem;
    width: 10rem;
    background: none;
    color: #fff;
    font-size: 1rem;
    letter-spacing: 1px;
    display: none;
}
// ::v-deep .el-carousel__indicators--outside{
//     position: absolute;
//     left: 27%;
//     top: 0%;
// }
// ::v-deep .el-carousel__container{
//     margin-top: 6%;
//     // height: 40vh !important;
// }
// ::v-deep .el-carousel__indicators--outside button{
//     opacity: 1;
// }
// ::v-deep .el-carousel__indicator.is-active button{
//     color: #54d1ef;
//     border-bottom: #54d1ef 2px solid;
// }
::v-deep .el-carousel__mask{
    background-color: #000;
    opacity: 0.6;
    z-index: 9;
}
// ::v-deep .el-carousel__item--card.is-in-stage:hover .el-carousel__mask{
//     opacity: 0.6;
// }
// ::v-deep .el-carousel__arrow{
//     width: 5%;
//     height: 15%;
//     color: #54d1ef;
//     font-size: 2rem;
// }
</style>